import { Box, Typography, Paper } from "@mui/material";
import { Lock as LockIcon } from "@mui/icons-material";

const Unauthorized = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
      }}>
      <Paper
        elevation={3}
        sx={{
          p: 4,
          maxWidth: 500,
          textAlign: "center",
        }}>
        <LockIcon sx={{ fontSize: 80, color: "error.main", mb: 2 }} />
        <Typography variant='h4' gutterBottom>
          Access Denied
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 3 }}>
          You do not have access to Enbase. Please contact an administrator if
          you believe this is an error.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
